import {
  Directive,
  ElementRef,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
} from '@angular/core';

import { SelectedTextOutput } from './liquid-page.models';

@Directive({
  selector: '[selectedTextDirective]'
})
export class SelectedTextDirective implements OnInit, OnDestroy {

  @Output() selectedTextDirective: EventEmitter<SelectedTextOutput> = new EventEmitter();
  @Output() emptySelection: EventEmitter<void> = new EventEmitter();

  private isMouseDown = false;

  constructor(
    private elementRef: ElementRef,
  ) { }

  ngOnInit() {
    this.elementRef.nativeElement.addEventListener('mousedown', this.handleMousedown, false);
    document.addEventListener('selectionchange', this.handleSelectionchange, false);
  }

  ngOnDestroy() {
    if (this.elementRef.nativeElement && this.elementRef.nativeElement.removeEventListener) {
      this.elementRef.nativeElement.removeEventListener('mousedown', this.handleMousedown, false);
    }
    if (document.removeEventListener) {
      document.removeEventListener('mouseup', this.handleMouseup, false);
      document.removeEventListener('selectionchange', this.handleSelectionchange, false);
    }
  }

  private getRangeContainer(range: Range): Node {
    let container = range.commonAncestorContainer;

    while (container.nodeType !== Node.ELEMENT_NODE && container.parentNode) {
      container = container.parentNode;
    }

    return container;
  }

  private handleMousedown = (event: MouseEvent) => {
    document.addEventListener('mouseup', this.handleMouseup, false);
    this.isMouseDown = true;
  }

  private handleMouseup = (event: MouseEvent) => {
    document.removeEventListener('mouseup', this.handleMouseup, false);
    this.isMouseDown = false;
    this.processSelection(event);
  }

  private handleSelectionchange = (event: Event) => {
    this.processSelection(event);
  }

  private processSelection = (event: Event) => {
    const selection = document.getSelection() ? document.getSelection() : undefined;
    if (!selection || !selection.rangeCount || !selection.toString() || this.isMouseDown) {
      if (!this.isMouseDown) {
        this.emptySelection.emit();
      }
      return;
    }

    const range = selection.getRangeAt(0);
    const rangeContainer = this.getRangeContainer(range);

    if (this.elementRef.nativeElement.contains(rangeContainer)) {
      const viewportRectangle = range.getBoundingClientRect();
      this.selectedTextDirective.emit({
        text: selection.toString(),
        left: viewportRectangle.left,
        top: viewportRectangle.top,
        width: viewportRectangle.width,
        height: viewportRectangle.height,
      });
    }
  }
}